import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import EntityField from '../../../../contentful/EntityField';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import update from 'immutability-helper';
import PublishStatusDot from '../../../../misc/PublishStatusDot.js';
// Style
import 'react-datepicker/dist/react-datepicker.css';

registerLocale('nb', dpLocale);

class CampaignOverride extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      override: {}
    };

    change.override[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      override: {}
    };

    if (e.target.type === 'checkbox') {
      newData.override[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.override[e.target.name] = {
        $set: e.target.value
      };
    }

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleDateChange(inputName, date) {
    const event = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(event);
  }

  render() {
    const override = this.props.override;

    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li>Motorforum</li>
          <li><Link to="/Motorforum/campaigns">Kampanjer</Link></li>
          <li>Overstyring</li>
          {override.name &&
              <li className="active">{override.name}</li>
          }
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1>
                  {override.name} <PublishStatusDot entry={override} /><br/>
                  <small>Kampanjeoverstyring</small>
                </h1>
              </div>

              <div className="col-xs-12 col-sm-4 text-right mf-padding-top-10">
                {this.props.working &&
                  <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
                }
                {!this.props.override.archived &&
                  <button
                    type="submit"
                    className="btn btn-default"
                    disabled={!this.props.modified || this.props.working}
                  >
                    {Boolean(this.props.override.id) &&
                      <span>Lagre</span>
                    }
                    {!this.props.override.id &&
                      <span>Opprett Overstyring</span>
                    }
                  </button>
                }
                &nbsp;
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(this.props.override.published && !this.props.override.updated) || this.props.override.archived || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onPublish();
                  }}
                >
                  <span>Publiser</span>
                </button>
                &nbsp;
                {this.props.onUnpublish &&
                  <button
                    type="button"
                    className="btn btn-warning"
                    disabled={this.props.override.draft || this.props.override.archived || this.props.working || this.props.modified}
                    onClick={(e) => {
                      e.preventDefault();
                      if (this.props.override.archived) {
                        this.props.onUnarchive();
                      } else {
                        this.props.onUnpublish();
                      }
                    }}
                  >
                    <span>Kladd</span>
                  </button>
                }
                &nbsp;
                {!this.props.override.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onArchive();
                    }}
                  >
                    <span>Arkiver</span>
                  </button>
                }
                &nbsp;
                {this.props.override.archived &&
                  <button
                    type="button"
                    className="btn btn-danger"
                    disabled={(this.props.working)}
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.onUnarchive();
                    }}
                  >
                    <span>Gjenopprett</span>
                  </button>
                }
              </div>
            </div>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Navn</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  defaultValue={override.name}
                  disabled={this.props.working || override.archived}
                  onChange={this.handleFieldChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Gjelder f.o.m. - t.o.m. <em className="small text-muted">(Påkrevet)</em></label>
                <div className="row">
                  <div className="col-xs-6">
                    <DatePicker
                      name="startDate"
                      disabled={this.props.working || override.archived}
                      className="form-control"
                      locale="nb"
                      dateFormat="dd.MM.yyyy"
                      selected={override.startDate}
                      onChange={(date) => date.setHours(0, 0, 0) && this.handleDateChange('startDate', date)}
                      required
                    />
                  </div>
                  <div className="col-xs-6">
                    <DatePicker
                      name="expiryDate"
                      disabled={this.props.working || override.archived}
                      className="form-control"
                      locale="nb"
                      dateFormat="dd.MM.yyyy"
                      selected={override.expiryDate}
                      onChange={(date) => date.setHours(23, 59, 59) && this.handleDateChange('expiryDate', date)}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <h4>Kampanje <em className="small text-muted">(Påkrevet)</em></h4>
              <EntityField
                name="campaign"
                contentType="campaign"
                value={override.campaign}
                onChange={this.handleAssetChange}
                disabled={this.props.working || override.archived}
                searchOnOpen={false}
                allowEdit={true}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="primary" defaultChecked={override.primary} onChange={this.handleFieldChange} disabled={this.props.working || override.archived} />
                  Primærkampanje
                </label>
              </div>

              <div className="form-group">
                <label>Plassering som skal overstyres</label>
                <select
                  className="form-control"
                  name="overrideIndex"
                  defaultValue={override.overrideIndex}
                  disabled={this.props.working || override.archived || override.primary}
                  onChange={this.handleFieldChange}
                >
                  <option value="">-- Velg plassering --</option>
                  <option value="0">1</option>
                  <option value="1">2</option>
                  <option value="2">3</option>
                  <option value="3">4</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </section>
    );
  }
}

CampaignOverride.defaultProps = {
  override: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default CampaignOverride;
